export const ALL_GROUP_NOTIFICATION = 'total'
